import {
  AfterViewInit,

  Component,
  EventEmitter,
  Input, OnInit,

  Output,

} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {state, style, trigger, transition, animate} from '@angular/animations';
import {select, Store} from '@ngrx/store';
import {ProjektState} from '../../store/reducer/projektverwaltung.reducer';
import {NodeItem} from '../../node.model';
import {pasteProjektStart} from '../../store/actions/projekt-paste.actions';
import {loadCopyNodesStart} from '../../store/actions/getCopyNodes.actions';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Security} from '../../../../security';
import {Observable} from 'rxjs';


@Component({
    selector: 'app-expandable-projekt-table',
    templateUrl: './projekt-expandable-table.component.html',
    styleUrls: ['./projekt-expandable-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ProjektExpandableTableComponent implements OnInit {


  constructor(
    private store: Store<{ projektverwaltung: ProjektState }>, public http: HttpClient, public router: Router, public security: Security)
  {
    // this.$nodes = store.pipe(select((state) => state.projektverwaltung.nodes.items));

  }

  public showFunctions: boolean;
  public dataSource = new MatTableDataSource<NodeItem>();
  columnsToDisplay = ['name', 'nummer', 'plz', 'ort', 'start', 'ende'];
  AllColumnsToDisplay = [ 'name', 'nummer', 'plz', 'ort', 'start', 'ende', 'actions'];
  columnsunter = ['name', 'nummer', 'plz', 'ort', 'start', 'ende'];
  columnsUnterprojekt = ['name', 'nummer', 'plz', 'ort', 'start', 'ende', 'actions'];
  arrOpen = [];
  isPasteable: boolean;

  @Output()
  public archiveProjekt = new EventEmitter<NodeItem>();

  @Output()
  public dearchiveProjekt = new EventEmitter<NodeItem>();

  @Output()
  public deleteProjekt = new EventEmitter<NodeItem>();

  @Output()
  public editProjekt = new EventEmitter<NodeItem>();

  @Output()
  public editProjektstufe = new EventEmitter<NodeItem>();

  @Output()
  public addProjektstufe = new EventEmitter<NodeItem>();

  @Input()
  copyNodes: NodeItem[] = [];

  public copyArray: NodeItem[];

  @Input()
  public set projekte(projekte: NodeItem[]) {
    console.log(projekte);
    this.dataSource.data = projekte;
    this.buildTree();



 //   this.arrOpen[0] = projekte[3];
 //   this.buildTree();
  }

  public   buildTree(): void{
    this.copyArray = this.arrOpen.slice();
    this.arrOpen.length = 0;
    for (let i = 0; i <= this.copyArray.length; ++i) {
      this.toggle(this.copyArray[i]);
    }
  }

  public ngOnInit(): void {
    this.security.checkLogin('2001').subscribe(
      x => {
        console.log(x);
        this.showFunctions = x;

      });
  }

  public copyProjektstufe(projekt: NodeItem): void{    // set Session with ProjektID, falls Projektid gesetzt ist kann man einfügen
     this.store.dispatch(loadCopyNodesStart({item: projekt}));
  }

  public pasteProjektstufe(projekt: NodeItem): void{
    this.store.dispatch(pasteProjektStart({item: projekt, copyNodes: this.copyNodes}));
  }

  public toggle(element: NodeItem): void{
    if ( element?.children[0]?.name === undefined){
      return;
    }
    else if (this.arrOpen[element.level]?.id === element?.id){
      this.arrOpen.splice(parseInt(element.level, 10));
      this.arrOpen[element.level] = null;
      return;
    }
    this.arrOpen.splice(parseInt(element.level, 10));
    this.arrOpen[element.level] = !element.children[0]?.name ? null : element;
  }
}

